import React from "react";
import "./GymFighters.css";
import GymFightersLogo from "../../../assets/GymFightersLogo.png";

function GymFighters() {
  return (
    <div className="gym-fighters-custom-1-container">
      <div className="gym-fighters-custom-1-content">
        <div className="gym-fighters-custom-1-text-container">
          <h1 className="gym-fighters-custom-1-main-title">GymFighters.com</h1>
          <h2 className="gym-fighters-custom-1-second-title">
            Sculpting Bodies, Unleashing Potential
          </h2>
          <p className="gym-fighters-custom-1-description">
            GymFighters.com is more than a fitness domain; it embodies a realm
            where dedication forges destinies. Immerse yourself in a world where
            fitness transcends routine to become an ethos. Our extensive range
            of fitness equipment isn't merely machinery; it serves as a catalyst
            for transformative change. Count on GymFighters.com not just to
            furnish gyms, but to sculpt futures. It's a commitment etched in
            iron, a promise forged in sweat, and a partnership fortified by
            unwavering determination.
            <br />
            <br />
            • An extensive collection encompassing a wide spectrum of fitness
            equipment and supplements.
            <br />
            • Premium-grade gym and bodybuilding equipment engineered to
            perfection.
            <br />
            • Fitness training accessories and gear curated for comprehensive
            workout experiences.
            <br />• Membership solutions catering to both individuals and gym
            proprietors.
          </p>
          
        </div>
        <a href="http://gymfighters.com/" target="_blank" rel="noopener noreferrer">
          <div className="gym-fighters-custom-1-logo-container">
            <img
              src={GymFightersLogo}
              alt="GymFightersLogo"
              className="gym-fighters-custom-1-logo"
            />
          </div>
        </a>
      </div>
    </div>
  );
}

export default GymFighters;
